import React from "react";
import { FiArrowLeft, FiInbox } from "react-icons/fi";
import { Link } from "react-router-dom";
import logo from "./assets/hallef-logo-cropped.png";
import "./empty-state.css";

export default function EmptyState() {
  return (
    <main className="empty-state-page">
      <Link to="/" aria-label="Hallef Technologies home">
        <img className="empty-state-logo" src={logo} alt="Hallef Technologies" />
      </Link>
      <section className="empty-state-card" aria-labelledby="empty-state-title">
        <div className="empty-state-icon" aria-hidden="true"><FiInbox /></div>
        <p className="empty-state-eyebrow">EMPTY STATE</p>
        <h1 id="empty-state-title">Nothing here yet</h1>
        <p className="empty-state-description">
          There’s no content to display right now. Check back later or head to the home page to explore more.
        </p>
        <Link className="empty-state-home" to="/">
          <FiArrowLeft aria-hidden="true" /> Back to Home
        </Link>
      </section>
      <p className="empty-state-footer">Hallef Technologies</p>
    </main>
  );
}
